var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-3"},[_c('button',{staticClass:"btn btn-sm btn--primary",on:{"click":_vm.openAddAccountModal}},[_vm._v(" Add Account ")]),_c('AddMoreAccountModal',{attrs:{"id":'addAccount',"accountFile":_vm.accountFile,"closeModal":_vm.closeModal,"updateAccountList":_vm.updateAccountList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }